export const DRAWER_PADDING_OFFSET = 100;
export const POPOUT_PADDING_OFFSET = 120;

export const DOCUMENT_NAV_STORAGE_SUFFIX = 'doc-navigation-config';
export const ACTIVE_TAB_STORAGE_SUFFIX = 'active-tab-id';

/** SessionStorage key for drawer document tabs, scoped to company + measurement date. */
export const buildDocumentNavStorageKey = (
  companyId: string | number | undefined | null,
  measurementDateId: string | number | undefined | null,
  applicationContext: string
): string =>
  `${companyId ?? 'company'}-${measurementDateId ?? 'no-md'}-${applicationContext}-${DOCUMENT_NAV_STORAGE_SUFFIX}`;
